import React, { useEffect } from "react";
import Pacsconfig from "../ConfigurePages/PacsconfigTable";
import HomeHeader from "../HomeHeader";
import "../HomeHeader.css";

import { useNavigate } from "react-router-dom";
import SideBar from "../SideBar/SideBar";

const Configure = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthenticated = localStorage.getItem("authenticated");
    if (isAuthenticated != "true") {
      navigate("/login");
    }
  });

  return (
    <div className="d-flex min-vh-100 overflow-auto background">
      <SideBar />
      <div >
        <HomeHeader />
        <div>
          <Pacsconfig />
        </div>
      </div>
    </div>
  );
};

export default Configure;
